import React from 'react';
import Chart from 'react-apexcharts';

const BarGraph = ({ graphData }) => {
  // console.log("printing props of bar graph ", graphData)
  const options = {
    chart: {
      id: 'basic-bar',
      toolbar: {
        show: false // Hide the entire toolbar
      }
    },
    xaxis: {
      categories: graphData ? graphData.categories : []
    },
    yaxis: {
      title: {
        text: 'Maneuver Score',
        style: {
          color: '#afafb7',
          fontFamily: 'Arial, sans-serif'
        }
      }
    },
    toolbar: {
      show: false // Hide the toolbar
    },
    title: {
      text: 'Latest Maneuver Score', // Specify the title for the whole graph here
      align: 'center',
      style: {
        fontSize: '12px',
        color: '#afafb7',
      },
      
    }
  }

    const series = [{
      name: graphData ? graphData.name : "",
      data: graphData ? graphData.data : []
    }];

    return(
    <div className = "bar-graph" >
        <Chart options={options} series={series} type="bar" height={500} />
    </div >
  );
};

export default BarGraph;
